import PropTypes from 'prop-types'

export default function Item({children}) {
  return <dl className="list list--product-warehouse">{children}</dl>
}

Item.propTypes = {
  children: PropTypes.node,
}
